import { useCallback } from 'react';
import i18n from 'i18next';

import { Popup, Tooltip } from 'web-components';
import { Flex, icons } from 'web-styled';

import type { Action } from './types';
import * as S from './styled';

type Props = {
  isOpen: boolean;
  isPro: boolean;
  avatar: string;
  namespace: any;
  profileActions: Action[];
  onToggle: () => void;
  onClose: () => void;
};

const ProfileDropdown = ({
  isOpen,
  isPro,
  avatar,
  namespace,
  profileActions,
  onToggle,
  onClose,
}: Props) => {
  const handleActionClick = useCallback((action: Action) => {
    action.action();
    onClose();
  }, [onClose]);

  const avatarSrc = avatar || namespace.webapp_logo_mark?.url;

  const avatarComponent = (
    <S.Avatar avatar={avatarSrc} />
  );

  return (
    <S.Dropdown
      width="76px"
      data-tour="tour__profile"
      isOpen={isOpen}
    >
      <Popup
        isOpen={isOpen}
        trigger={(
          <Flex>
            {isPro ? (
              <Tooltip
                body={i18n.t('tooltip.main.header.user')}
                isOpen={isOpen ? false : undefined}
                positions={['left']}
              >
                {avatarComponent}
              </Tooltip>
            ) : (
              avatarComponent
            )}
          </Flex>
        )}
        setPopupVisible={onToggle}
        onClickOutside={onClose}
      >
        <S.Actions>
          {profileActions.map(item => (
            <S.Action
              key={item.name}
              onClick={() => handleActionClick(item)}
            >
              <Flex flex="0 0 25%">
                <S.ActionIcon
                  icon={item.icon}
                  style={{
                    backgroundImage: `url(${icons[item.icon]})`,
                  }}
                />
              </Flex>
              <span>{item.name}</span>
            </S.Action>
          ))}
        </S.Actions>
      </Popup>
    </S.Dropdown>
  );
};

export default ProfileDropdown;
